import { View } from './view'

export const PageLayoutShotApplication = View
